import {useEffect, useState} from 'react';

// Ширина, с которой раскладка матча десктопная: строка игроков стоит в
// шапке, а не полосой под ней, панель осмотра ячейки разложена в три колонки
// (та же граница, что у @media (min-width: 1024px) в CSS матча)
export const DESKTOP_LAYOUT_MIN_WIDTH_PX = 1024;

const checkIfMatchMediaAvailable = () => (
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
);

/**
 * Не уже ли окно заданной ширины — для случаев, когда одной CSS-раскладкой не
 * обойтись и разметка должна быть разной
 *
 * @param {number} minWidth
 * @returns {boolean}
 */
export const useMinWidthLayout = (minWidth) => {
  const query = `(min-width: ${minWidth}px)`;
  const [isWideScreen, setIsWideScreen] = useState(
    () => checkIfMatchMediaAvailable() && window.matchMedia(query).matches
  );

  useEffect(() => {
    // Окружение без matchMedia (jsdom в тестах без мока) — узкая раскладка
    if (!checkIfMatchMediaAvailable()) {
      return undefined;
    }
    const mediaQuery = window.matchMedia(query);
    const syncFromMediaQuery = () => setIsWideScreen(mediaQuery.matches);

    mediaQuery.addEventListener('change', syncFromMediaQuery);
    // Резерв: отдельные окружения (например, эмуляция вьюпорта в devtools) не
    // диспатчат change у matchMedia — обычный resize приходит всегда, а
    // setState с тем же значением ре-рендер не вызывает (тот же прием, что и
    // в RulesModal)
    window.addEventListener('resize', syncFromMediaQuery);
    // Между первым рендером и эффектом окно могло смениться (поворот экрана,
    // открытие в развернутом окне)
    syncFromMediaQuery();

    return () => {
      mediaQuery.removeEventListener('change', syncFromMediaQuery);
      window.removeEventListener('resize', syncFromMediaQuery);
    };
  }, [query]);

  return isWideScreen;
};

/**
 * Десктопная ли раскладка матча (строка игроков в шапке; панель осмотра ячейки
 * показывает описание строения целиком вместо ссылки «Подробнее»)
 *
 * @returns {boolean}
 */
export const useDesktopLayout = () => useMinWidthLayout(DESKTOP_LAYOUT_MIN_WIDTH_PX);
